import type { FC, HTMLAttributes } from 'react';
import { Play } from '@phosphor-icons/react';

import { cn } from '@/lib/utils';

export interface PlayButtonProps extends HTMLAttributes<HTMLDivElement> {
    variant?: string;
}

const PlayButton: FC<PlayButtonProps> = ({ className }) => (
    <div
        className={cn(
            'absolute left-1/2 top-1/2 z-20 h-[110px] w-[110px] translate-x-[-50%] translate-y-[-50%] rounded-full bg-whiteRing p-5',
            className,
        )}
    >
        <Play
            size={73}
            color="#ffffff"
            weight="fill"
        />
    </div>
);

export default PlayButton;
